import { Row } from "@hightouch/htui";
import { Pagination as TablePagination } from "src/ui/table/pagination";
import type {
  Paged,
  PagingState,
} from "src/pages/ad-studio/insights/performance/view/types";

type ListPagerProps = {
  paging: PagingState;
  performAction: (action: Paged) => void;
};

export const ListPager = ({ paging, performAction }: ListPagerProps) => {
  switch (paging.kind) {
    case "no-rows":
    case "one-page": {
      return null;
    }
    case "pages": {
      return (
        <Row justify="flex-start" px={3} py={2}>
          <TablePagination
            page={paging.page}
            setPage={(page) =>
              performAction({ kind: "PerformanceViewAction/paged", page })
            }
            count={paging.total}
            rowsPerPage={paging.rowsPerPage}
            label={paging.noun}
            compact
          />
        </Row>
      );
    }
    default: {
      return paging satisfies never;
    }
  }
};
